import { Grid, Typography } from '@material-ui/core';
import React, { useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import { setHomePage } from 'src/common/components/emerald-home-page/emerald-home-page';
import { IItemLookup } from 'src/common/interfaces/dtos/IItemLookup';
import { POSModeState } from 'src/common/interfaces/states/POSModeState';
import { useTranslation } from 'react-i18next';
import { AppState } from 'src/common/redux/configure-store';
import { trainingModeStyles } from 'src/common/training-mode/training-mode-styles';
import Keypad from 'src/keypad/components/keypad';
import ManualVolumeItemWindow from './manual-volume-item-window';
import { manualVolumeStyles } from './manual-volume-styles';
import { IItemInputData } from 'src/common/interfaces/IItemInputData';

type Props = IManualVolumeProps;

export const showManualVolumeWindow = (props: Props): void => {
  setHomePage(<ManualVolume {...props} />);
};

const ManualVolume: React.FC<Props> = (props: Props): JSX.Element => {
  const classes = manualVolumeStyles();
  const trainingModeClasses = trainingModeStyles();
  const isLeftHanded = useSelector(
    (state: AppState): boolean => state.cashierPreferences.leftHanded,
  );
  const posModeState = useSelector((state: AppState): POSModeState => state.posMode);
  const { t } = useTranslation();

  const [manualQuantity, setManualQuantity] = useState(
    props.inputData?.manualQuantity?.toString() || '',
  );

  const isDefaultQuantity = useRef<boolean>(true);
  const setNewManualQuantity = (input: string): void => {
    if (isDefaultQuantity.current) {
      input = input.slice(-1);
      isDefaultQuantity.current = false;
    }
    setManualQuantity(input);
  };

  const ManualVolumeKeypad = (): JSX.Element => {
    return (
      <Grid item className={classes.keypadContainer}>
        <Keypad
          visible
          keyboardId='manual-volume'
          submitButton={{
            label: 'OK',
            onClick: props.onKeypadSubmit,
          }}
          topLabelText={t('ManualVolume_EnterVolume')}
          keypadTestIdPrefix='manual-volume-'
          disableQuantity
          disableManualWeight
          disableSubmitWhenNoInput
          handleOnInputChange={setNewManualQuantity}
          initialInputValue={manualQuantity}
        />
      </Grid>
    );
  };

  return (
    <Grid item className={`fullHeight flexFull`} style={{ width: '0' }} data-testid='manual-volume'>
      <Grid item className={`${classes.background} fullWidth fullHeight`}>
        <Grid
          container
          direction='column'
          style={{ flex: '1 1 0' }}
          className={`fullHeight ${classes.manualVolumeContainer} ${
            posModeState.trainingMode ? trainingModeClasses.trainingModeBackground : ''
          }`}
          data-testid='manual-volume-container'
        >
          <Grid item className={classes.fitHeight} data-testid='manual-volume-subContainer'>
            <Grid container direction='column' className='fullWidth'>
              <Grid item>
                <Typography
                  className={`${classes.manualVolumeTitleHeader} ${classes.manualVolumeTitleHeaderLabel}`}
                  data-testid='manual-volume-title-text'
                >
                  {t('ManualVolume_header')}
                </Typography>
              </Grid>
              <Grid item xs={1}>
                <Typography className={`${classes.manualVolumeTitleBar}`} />
              </Grid>
            </Grid>
          </Grid>
          <Grid item container style={{ flex: 1 }}>
            {isLeftHanded && <ManualVolumeKeypad />}
            <ManualVolumeItemWindow itemData={props.itemLookup} onCancel={props.onCancel} />
            {!isLeftHanded && <ManualVolumeKeypad />}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export interface IManualVolumeProps {
  onKeypadSubmit: (itemId: string) => void;
  onCancel: () => void;
  itemLookup: IItemLookup;
  inputData?: IItemInputData;
}
export default ManualVolume;
